<template>
    
    <v-layout row wrap>
            
        <v-tabs dark centered>

            <v-tabs-bar class="grey darken-3">
               <v-tabs-slider color="orange"></v-tabs-slider>
                    <v-tabs-item href="#tab1" >
                        <v-btn flat class="grey--text">
                            Anschriftsdaten
                        </v-btn>
                    </v-tabs-item>
            </v-tabs-bar>    

            <v-tabs-items>
                <v-tabs-content id="tab1">
                    <div>
                        <keep-alive>
                            <form-one v-on:submitted="submitForm"></form-one>
                        </keep-alive>
                    </div>
                </v-tabs-content>
            </v-tabs-items>
        </v-tabs>    
              
    </v-layout>

    
</template>

<script>

import formOne from './createAdressen_1.vue';

export default {
    components: {
        'form-one': formOne,
        
    },
    data() {
        return {
            
                 
        }
    }, 
    methods: {
        
        submitForm: function(ad) {
            this.$store.commit('setMessagebar', false)             
            this.$store.dispatch('postAdresse', ad).then((response) => {  
                this.$store.commit('setMessagebar', true)  
                this.$store.dispatch('setAdresse', response.id).then(()=>{
                    this.$router.replace({name:'adressen_edit', params: {id: response.id}})                
                })
            })
                         
        }
    },
    created(){
        
        
    },
    
}
</script>

<style>
   
    
</style>



// WEBPACK FOOTER //
// createAdressen.vue?a0f7b814